import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { HealthHistoryItem } from "@/types/HealthHistoryItem";

interface HealthHistoryState { items: HealthHistoryItem[]; isLoading: boolean; }
const initialState: HealthHistoryState = { items: [], isLoading: false };

export const getHealthHistory = createAsyncThunk(
  "healthHistory/getHealthHistory",
  async ({ address }: { address: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/healthHistory/${address}`);
    return response.data;
  }
);

const healthHistorySlice = createSlice({
  name: "healthHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHealthHistory.pending, (state) => { state.isLoading = true; })
      .addCase(getHealthHistory.fulfilled, (state, { payload }) => { state.items = payload; state.isLoading = false; })
      .addCase(getHealthHistory.rejected, (state) => { state.isLoading = false; });
  },
});

export default healthHistorySlice.reducer;
